// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MarkerObjectsList_dynamic-list__m3pAX {
  padding: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 {
  padding: 0 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 h6 {
  font-size: 1.5rem;
  margin-bottom: 5px;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul {
  padding: 10px 0;
  margin-bottom: 0;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0px 5px;
  /* row-gap column gap */
  justify-content: space-evenly;
  max-height: 200px;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul::-webkit-scrollbar {
  display: none;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li {
  width: -moz-fit-content;
  width: fit-content;
  list-style: none;
  transform: rotate(5deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(2n) {
  transform: rotate(-4deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(3n) {
  transform: rotate(2deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(4n) {
  transform: rotate(-5deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(5n) {
  transform: rotate(-6deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(6n) {
  transform: rotate(6deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(7n) {
  transform: rotate(-3deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(8n) {
  transform: rotate(4deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(9n) {
  transform: rotate(1deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li:nth-child(10n) {
  transform: rotate(-1deg);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li .MarkerObjectsList_clickable-name__s3R1j {
  font-weight: inherit;
  color: inherit;
  font-size: 1.2rem;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  border: none;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li .MarkerObjectsList_clickable-name__s3R1j:hover {
  color: var(--accent-color);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li a {
  font-weight: inherit;
  color: inherit;
  font-size: 1.2rem;
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul li a:hover {
  color: var(--accent-color);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul .MarkerObjectsList_highlighted__RYQTy {
  animation: MarkerObjectsList_highlight-element__Ap02v 5s ease;
}
@keyframes MarkerObjectsList_highlight-element__Ap02v {
  0% {
    padding: 0 5px;
    background-color: transparent;
    box-shadow: 0 0 0 3px transparent;
  }
  15% {
    background-color: rgb(187, 79, 187);
    box-shadow: 0 0 0 3px rgb(187, 79, 187);
  }
  20% {
    background-color: rgb(187, 79, 187);
    box-shadow: 0 0 0 3px rgb(187, 79, 187);
  }
  99% {
    padding: 0 5px;
  }
  100% {
    background-color: transparent;
    box-shadow: 0 0 0 3px transparent;
    padding: 0;
  }
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul .MarkerObjectsList_see-more__MWUWE {
  color: rgb(100, 100, 100);
}
.MarkerObjectsList_dynamic-list__m3pAX .MarkerObjectsList_elements__tPNe5 ul:hover .MarkerObjectsList_see-more__MWUWE {
  color: rgb(6, 91, 189);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/MarkerObjectsList/MarkerObjectsList.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACR;AACQ;EACI,iBAAA;EACA,kBAAA;AACZ;AAEQ;EACI,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EAEA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AAFZ;AAIY;EACI,aAAA;AAFhB;AAKY;EACI,uBAAA;EAAA,kBAAA;EACA,gBAAA;EAEA,uBAAA;AAJhB;AAMgB;EACI,wBAAA;AAJpB;AAOgB;EACI,uBAAA;AALpB;AAQgB;EACI,wBAAA;AANpB;AASgB;EACI,wBAAA;AAPpB;AAUgB;EACI,uBAAA;AARpB;AAWgB;EACI,wBAAA;AATpB;AAYgB;EACI,uBAAA;AAVpB;AAagB;EACI,uBAAA;AAXpB;AAcgB;EACI,wBAAA;AAZpB;AAegB;EACI,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;AAbpB;AAeoB;EACI,0BAAA;AAbxB;AAiBgB;EACI,oBAAA;EACA,cAAA;EACA,iBAAA;AAfpB;AAiBoB;EACI,0BAAA;AAfxB;AAoBY;EACI,6DAAA;AAlBhB;AAqBgB;EACI;IACI,cAAA;IACA,6BAAA;IACA,iCAAA;EAnBtB;EAsBkB;IACI,mCAVU;IAWV,uCAAA;EApBtB;EAuBkB;IACI,mCAfU;IAgBV,uCAAA;EArBtB;EAwBkB;IACI,cAAA;EAtBtB;EAyBkB;IACI,6BAAA;IACA,iCAAA;IACA,UAAA;EAvBtB;AACF;AA2BY;EACI,yBAAA;AAzBhB;AA6BY;EACI,sBAAA;AA3BhB","sourcesContent":[".dynamic-list {\n    padding: 10px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n\n    .elements {\n        padding: 0 10px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        h6 {\n            font-size: 1.5rem;\n            margin-bottom: 5px;\n        }\n\n        ul {\n            padding: 10px 0;\n            margin-bottom: 0;\n            // list-style-image: url(\"data:image/svg+xml,%3Csvg width='8.5814px' height='8.4374px' version='1.1' viewBox='0 0 85.814 84.374' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='42' cy='42' r='25' fill='%230bb12f'/%3E%3C/svg%3E%0A\");\n            text-align: center;\n            width: fit-content;\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            align-items: center;\n            gap: 0px 5px;\n            /* row-gap column gap */\n            justify-content: space-evenly;\n            // create a limit for the size of the list, and make it scrollable\n            max-height: 200px;\n            overflow: scroll;\n            -ms-overflow-style: none;\n            scrollbar-width: none;\n\n            &::-webkit-scrollbar {\n                display: none;\n            }\n\n            li {\n                width: fit-content;\n                list-style: none;\n\n                transform: rotate(5deg);\n\n                &:nth-child(2n) {\n                    transform: rotate(-4deg);\n                }\n\n                &:nth-child(3n) {\n                    transform: rotate(2deg);\n                }\n\n                &:nth-child(4n) {\n                    transform: rotate(-5deg);\n                }\n\n                &:nth-child(5n) {\n                    transform: rotate(-6deg);\n                }\n\n                &:nth-child(6n) {\n                    transform: rotate(6deg);\n                }\n\n                &:nth-child(7n) {\n                    transform: rotate(-3deg);\n                }\n\n                &:nth-child(8n) {\n                    transform: rotate(4deg);\n                }\n\n                &:nth-child(9n) {\n                    transform: rotate(1deg);\n                }\n\n                &:nth-child(10n) {\n                    transform: rotate(-1deg);\n                }\n\n                .clickable-name {\n                    font-weight: inherit;\n                    color: inherit;\n                    font-size: 1.2rem;\n                    cursor: pointer;\n                    background-color: transparent;\n                    padding: 0;\n                    border: none;\n\n                    &:hover {\n                        color: var(--accent-color)\n                    }\n                }\n\n                a {\n                    font-weight: inherit;\n                    color: inherit;\n                    font-size: 1.2rem;\n\n                    &:hover {\n                        color: var(--accent-color)\n                    }\n                }\n            }\n\n            .highlighted {\n                animation: highlight-element 5s ease;\n                $highlight-color: rgb(187, 79, 187);\n\n                @keyframes highlight-element {\n                    0% {\n                        padding: 0 5px;\n                        background-color: transparent;\n                        box-shadow: 0 0 0 3px transparent;\n                    }\n\n                    15% {\n                        background-color: $highlight-color;\n                        box-shadow: 0 0 0 3px $highlight-color;\n                    }\n\n                    20% {\n                        background-color: $highlight-color;\n                        box-shadow: 0 0 0 3px $highlight-color;\n                    }\n\n                    99% {\n                        padding: 0 5px;\n                    }\n\n                    100% {\n                        background-color: transparent;\n                        box-shadow: 0 0 0 3px transparent;\n                        padding: 0;\n                    }\n                }\n            }\n\n            .see-more {\n                color: rgb(100, 100, 100);\n                // font-weight: 500;\n            }\n\n            &:hover .see-more {\n                color: rgb(6, 91, 189);\n            }\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dynamic-list": `MarkerObjectsList_dynamic-list__m3pAX`,
	"elements": `MarkerObjectsList_elements__tPNe5`,
	"clickable-name": `MarkerObjectsList_clickable-name__s3R1j`,
	"highlighted": `MarkerObjectsList_highlighted__RYQTy`,
	"highlight-element": `MarkerObjectsList_highlight-element__Ap02v`,
	"see-more": `MarkerObjectsList_see-more__MWUWE`
};
export default ___CSS_LOADER_EXPORT___;
